import {
  DEFAULT_THEME,
  HoverCard,
  type MantineThemeOverride,
  Modal,
  MultiSelect,
  Select,
  Switch,
  Text,
  Tooltip,
} from '@mantine/core';
import { THEME_COLORS } from '@vrplatform/ui-common';

export type AppTheme = 'finalytic' | 'vrplatform';

export const theme: MantineThemeOverride = {
  // colorScheme: 'light',
  primaryColor: 'dark', // Mantine color "dark" from default color scheme
  fontFamily: 'Inter',
  radius: { ...DEFAULT_THEME.radius, md: '0.375rem', lg: '0.5rem' },
  fontSizes: {
    xs: '0.8125rem',
  },
  components: {
    Modal: Modal.extend({
      defaultProps: {
        centered: true,
        styles: {
          title: {
            fontWeight: 500,
          },
        },
      },
    }),
    Switch: Switch.extend({
      defaultProps: {
        // ✅ Disable withThumbIndicator if you want to use old styles
        withThumbIndicator: false,
      },
    }),
    Text: Text.extend({
      defaultProps: {
        size: 'sm',
      },
    }),
    Tooltip: Tooltip.extend({
      defaultProps: {
        withArrow: true,
      },
    }),
    HoverCard: HoverCard.extend({
      defaultProps: {
        shadow: 'md',
        withArrow: true,
        radius: 'md',
      },
    }),
    Select: Select.extend({
      defaultProps: {
        radius: 'md',
      },
      styles: (theme) => ({
        input: {
          '&:focus': {
            boxShadow: `0px 0px 0px 2px ${
              theme.colors[theme.primaryColor][4]
            }40`,
          },
        },
      }),
    }),
    MultiSelect: MultiSelect.extend({
      defaultProps: {
        radius: 'md',
      },
      styles: (theme) => ({
        input: {
          '&:focus-within': {
            boxShadow: `0px 0px 0px 2px ${
              theme.colors[theme.primaryColor][4]
            }40`,
          },
        },
      }),
    }),
  },
  headings: {
    sizes: {
      h1: { fontSize: '2rem' },
      h2: { fontSize: '1.5rem' },
      h3: { fontSize: '1.25rem' },
      h4: { fontSize: '1rem' },
      h5: { fontSize: '0.875rem' },
      h6: { fontSize: '0.75rem' },
    },
  },
  shadows: {
    xxs: '0px 1px 1px 0px rgba(0, 0, 0, 0.06)',
  },
  other: {
    border: {
      button: '1px solid rgba(23, 23, 23, 0.07)',
    },
  },
  colors: THEME_COLORS,
};
